module.exports = __webpack_public_path__ + "img/left_bg.6c9bc22.png";